export const APP = {
  name: 'MyTownly',
  town: 'Piler, Andhra Pradesh',
  supportPhone: '917730896459',
  supportWhatsapp: '917730896459',
  supportEmail: 'hello@mytownly.in',
};
